var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOracle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4562 22.7562C6.14733 22.7562 2.7002 19.2896 2.7002 14.9562C2.7002 10.6229 6.14733 7.15625 10.4562 7.15625H19.5441C23.8531 7.15625 27.3002 10.6229 27.3002 14.9562C27.3002 19.2896 23.8531 22.7562 19.5441 22.7562H10.4562ZM19.3091 19.9987C22.1295 19.9987 24.3231 17.7138 24.3231 14.9562C24.3231 12.1199 22.0512 9.91383 19.3091 9.91383H10.6913C7.8709 9.91383 5.67727 12.1987 5.67727 14.9562C5.67727 17.7138 7.94924 19.9987 10.6913 19.9987H19.3091Z",
    fill: "#C74634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOracle);
export default __webpack_public_path__ + "static/media/oracle.f4211fcc464a593673e679ecf69e0418.svg";
export { ForwardRef as ReactComponent };